import { FILE } from "Constants";

export const createFormData = (file) => {
  const formData = new FormData();
  formData.append(FILE, file[0]);
  return formData;
}